import useSWR from "swr";
import { api, fetcher } from "@api/_base";
import { SeoDtoResponse } from '@interfaces/dto/seo.dto';
import { SITE_DEFAULT_PAGESIZE } from '@const/seo.const';

// SEO Homepage and CMS Page
export const useSeoCmsDetail = (
  urlKey: string | undefined
): SeoDtoResponse => {
  const { data, error, mutate } = useSWR(
    urlKey ? `/nextapi/seo/page?searchCriteria[filterGroups][0][filters][0][field]=identifier&searchCriteria[filterGroups][0][filters][0][value]=${urlKey}` : undefined,
    fetcher
  );

  return {
    data: data && data.length > 0 ? data[0] : undefined,
    isLoading: !error && !data,
    error: error,
    mutate: mutate,
  };
};

// SEO Product Detail Page
export const useSeoProductDetail = (
  productId: string | undefined
): SeoDtoResponse => {
  const { data, error, mutate } = useSWR(
    productId ? `/nextapi/seo/product/${productId}` : undefined,
    fetcher
  );

  return {
    data: data && data.length > 0 ? data[0] : undefined,
    isLoading: !error && !data,
    error: error,
    mutate: mutate,
  };
};

// SEO Category Page
export const useSeoCategoryDetail = (
  categoryId: string | undefined
): SeoDtoResponse => {
  const { data, error, mutate } = useSWR(
    categoryId ? `/nextapi/seo/category/${categoryId}` : undefined,
    fetcher
  );

  return {
    data: data && data.length > 0 ? data[0] : undefined,
    isLoading: !error && !data,
    error: error,
    mutate: mutate,
  };
};

// SEO Brand Page
export const useSeoBrandDetail = (
  brandId: string | undefined
): SeoDtoResponse => {
  const { data, error, mutate } = useSWR(
    brandId ? `/nextapi/seo/brand/${brandId}` : undefined,
    fetcher
  );

  return {
    data: data && data.length > 0 ? data[0] : undefined,
    isLoading: !error && !data,
    error: error,
    mutate: mutate,
  };
};

// SITEMAP ALL PRODUCTS
const defaultPageSize = SITE_DEFAULT_PAGESIZE;

export const calculateTotalPages = (totalItems: number, pageSize:number) => {
  return Math.ceil(totalItems / pageSize);
};

export const fetchProductByPageSize = async (pageSize: number, currentPage: number) => {
  try {
    const productResp = await api.get(`/nextapi/products/feed?searchCriteria[pageSize]=${pageSize}&searchCriteria[currentPage]=${currentPage}`)
    return productResp.data;
  } catch (error) {
    console.error(error);
  }
}

export const fetchAllProductsData = async (pageSize = defaultPageSize) => {
  let allData: any = {}
  let pageNumber = 1;

  // Get the first page of data
  let pageData = await fetchProductByPageSize(pageSize, pageNumber);
  allData = {
      items: [...pageData.items]
  };

  // const totalCount = 6;
  const totalCount = pageData.total_count;
  const totalPages = calculateTotalPages(totalCount, pageSize);

  while (pageNumber < totalPages) {
    pageNumber++;
    pageData = await fetchProductByPageSize(pageSize, pageNumber);
    allData = {
      items: [
        ...allData.items, ...pageData.items
      ]
    }
  }
  return allData;
}
  

